export default defineAppConfig({
  ui: {
    colors: {
      primary: 'green',
      neutral: 'neutral'
    },
    icons: ['lucide', 'simple-icons']
  },
  monitoring: {
    title: 'Monitoring Dashboard',
    refreshInterval: 30000, // 30 seconden
    maxDataPoints: 1000,
    notificationSettings: {
      email: true,
      push: true,
      webhook: false
    }
  }
})
